<dx-form class="plain-styled-form" [screenByWidth]="getSizeQualifier">
    <dxi-item itemType="group">
        <dxo-col-count-by-screen
            [xs]="1"
            [sm]="2"
            [md]="2"
            [lg]="2"
        ></dxo-col-count-by-screen>
        <dxi-item [colSpan]="2">
            <pictured-item-select-box 
                    [value]="data.employeeId" 
                    (valueChange)="onEmployeeChange($event)" 
                    [dataSource]="employeesDataSource" label="Employee:*">
            </pictured-item-select-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
            <dx-select-box
                label="Staging Lane:*"
                stylingMode='filled'
                valueExpr="value"
                displayExpr="text"
                [items]="stagingLaneOptions"
                [(value)]="data.stagingLane"
                [searchEnabled]="true">
                <dx-validator>
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
            </dx-select-box>
        </dxi-item>
    </dxi-item>
</dx-form>